import Vue from 'vue'
import Router from 'vue-router'

// Containers
import Full from '@/containers/Full'

// Views
import Dashboard from '@/views/Dashboard/Dashboard'

import Reach from '@/views/reach/Reach'
import ReachResult from '@/views/reach/ReachResult'
import ReachDA from '@/views/reach/da/Reach'
import ReachDAResult from '@/views/reach/da/ReachResult'

import Budget from '@/views/budget/Budget'
import MediaBudgetResult from '@/views/budget/MediaBudgetResult'
import MediaReachResult from '@/views/budget/MediaReachResult'
import ChannelBudgetResult from '@/views/budget/ChannelBudgetResult'
import ChannelReachResult from '@/views/budget/ChannelReachResult'

import Compare from '@/views/compare/Compare'

import ReachCurve from '@/views/reachCurve/ReachCurve'

import ModelCustom from '@/views/modelCustom/modelCustom'

import SystemInfo from '@/views/help/SystemInfo'

import Coefficient from '@/views/management/coefficient/Coefficient'
import NielsenData from '@/views/management/nielsen/NielsenData'
import DMCData from '@/views/management/dmcdata/DMCData'

import Notice from '@/views/management/board/Notice'
import QA from '@/views/management/board/QA'
import BoardEditor from '@/views/management/board/BoardEditor'
import BoardManager from '@/views/management/board/BoardManager'

import User from '@/views/management/user/User'

// Views - Pages
import Page404 from '@/views/pages/Page404'
import Page500 from '@/views/pages/Page500'
import Login from '@/views/pages/Login'
import Register from '@/views/pages/Register'
import Loading from '@/views/pages/Loading'

// 2108.05.23
import store from '@/store/store.js';

// 2018.07.11
// import testInputLevelResult from '@/views/test/InputLevelResult0';
// 2018.11.02
import CampaignInfoList from '@/views/management/CampaignInfo/CampaignInfoList'

Vue.use(Router)

const router = new Router({
  mode: 'hash', // Demo is living in GitHub.io, so required!
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: Full,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard
        }
      ]
    },
    {
      path: '/reach',
      name: 'Reach Simulation Root',
      component: Full,
      children: [
        {
          path: 'reach',
          name: 'Reach Simulation',
          component: Reach
        },
        {
          path: 'result',
          name: 'Reach Simulation Result',
          component: ReachResult
        },
        {
          path: 'da/reach',
          name: 'Reach Simulation DA',
          component: ReachDA
        },
        {
          path: 'da/result',
          name: 'Reach Simulation DA Result',
          component: ReachDAResult
        },
      ]
    },
    {
      path: '/budget',
      name: 'Budget Simulation',
      component: Full,
      children: [
        {
          path: 'budget',
          name: 'Budget Allocation',
          component: Budget
        },
        {
          path: 'mediaBudgetResult',
          name: 'Media Max Reach Result',
          component: MediaBudgetResult
        },
        {
          path: 'mediaReachResult',
          name: 'Media Least Budget Result',
          component: MediaReachResult
        },
        {
          path: 'channelBudgetResult',
          name: 'Channel Max Reach Result',
          component: ChannelBudgetResult
        },
        {
          path: 'channelReachResult',
          name: 'Channel Least Budget Result',
          component: ChannelReachResult
        },
      ]
    },
    {
      path: '/curve',
      name: 'Reach Curve Simulation',
      component: Full,
      children: [
        {
          path: 'curve',
          name: 'Reach Curve',
          component: ReachCurve
        }
      ]
    },
    {
      path: '/model',
      name: 'Model Customizing',
      component: Full,
      children: [
        {
          path: 'customizing',
          name: 'model Customizing',
          component: ModelCustom
        }
      ]
    },
    {
      path: '/compare',
      name: 'Compare Simulation',
      component: Full,
      children: [
        {
          path: 'compare',
          name: 'Compare',
          component: Compare
        }
      ]
    },
    {
      path: '/help',
      name: 'Help',
      component: Full,
      children: [
        {
          path: 'systeminfo',
          name: 'SystemInfo',
          component: SystemInfo
        }
      ]
    },
    {
      path: '/data',
      name: 'Data Management Coefficient',
      component: Full,
      children: [
        {
          path: 'coefficient',
          name: 'Coefficient',
          component: Coefficient
        }
      ]
    },
    {
      path: '/data',
      name: 'Data Management Nielsendata',
      component: Full,
      children: [
        {
          path: 'nielsendata',
          name: 'Nielsen Data',
          component: NielsenData
        }
      ]
    },
    {
      path: '/data',
      name: 'Data Management',
      component: Full,
      children: [
        {
          path: 'dmcdata',
          name: 'DMC Data',
          component: DMCData
        }
      ]
    },
    {
      path: '/data',
      name: 'CampaignInfoList root',
      component: Full,
      children: [
        {
          path: 'b3148b70-de78-11e8-b568-0800200c9a66',
          name: 'CampaignInfoList',
          component: CampaignInfoList
        }
      ]
    },
    {
      path: '/board',
      name: 'Board Management Notice',
      component: Full,
      children: [
        {
          path: 'notice',
          name: 'Notice',
          component: Notice
        }
      ]
    },
    {
      path: '/board',
      name: 'Board Management Q&A',
      component: Full,
      children: [
        {
          path: 'qa',
          name: 'Q&A',
          component: QA
        }
      ]
    },
    {
      path: '/board',
      name: 'Board Editor',
      component: Full,
      children: [
        {
          path: 'editor',
          name: 'Editor',
          component: BoardEditor
        }
      ]
    },
    {
      path: '/board',
      name: 'Board Manager',
      component: Full,
      children: [
        {
          path: 'manager',
          name: 'Manager',
          component: BoardManager
        }
      ]
    },
    {
      path: '/user',
      name: 'User Management',
      component: Full,
      children: [
        {
          path: 'user',
          name: 'User',
          component: User
        }
      ]
    },
    {
      path: '/loading',
      name: 'Page Loading',
      component: Full,
      children: [
        {
          path: 'loading',
          name: 'loading',
          component: Loading
        }
      ]
    },
    {
      path: '/pages',
      redirect: '/pages/Login',
      name: 'Login Root',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: 'login',
          name: 'Login',
          component: Login
        }
      ]
    },
  ]
})

router.beforeEach((to, from, next) => {

  if(to.path !== '/pages/login'){

    // 엑세스 토큰이 살아있는지 체크하는 로직
    const http = new XMLHttpRequest();
    const url = store.getters.getAPIDomain + '/oauth/check_token';
    var params = 'token=' + sessionStorage.getItem("myToken");

    http.open('POST', url, true);
    //Send the proper header information along with the request
    http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
    http.setRequestHeader('Authorization', store.getters.getCredentialCode);

    http.onreadystatechange = function() { //Call a function when the state changes.
        if(http.readyState == 4 && http.status == 200) {
            return next();
        }else if(http.status !== 200) {
            return next({ path: '/pages/login' });
        }else {
        }
    }
    http.send(params);
  }else{
    next();
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/router.js